import React from 'react'
import PropTypes from 'prop-types'
import useScreen from '../../../hooks/useScreen'

const NotFoundResults = ({ query, cols }) => {
    const { isMobile } = useScreen()

    return (
        <div className="w-full h-auto flex flex-col items-start justify-start md:bg-transparent bg-white">
            {!isMobile && (
                <div className="w-full h-12 bg-pageBackground flex items-center justify-center border-b border-t border-grayLines px-4 transition-all">
                    {cols?.map(item => {
                        return (
                            <p
                                className="flex-grow text-textDarkerGray text-sm font-normal"
                                key={item?.field}
                            >
                                {item?.value}
                            </p>
                        )
                    })}
                </div>
            )}
            <div className="w-full h-auto px-4 py-6 gap-y-4 flex flex-col border-grayLines md:border-t-0 border-t">
                <p className="font-medium text-lg text-black90">
                    No results {`${query ? `for "${query}"` : 'found'}`}
                </p>

                <p className="text-textDarkerGray font-normal text-base leading-4.75">
                    We did not find anything matching your search criteria at
                    this time.
                </p>
            </div>
        </div>
    )
}

NotFoundResults.propTypes = {
    query: PropTypes.string,
    cols: PropTypes.array,
}

export default NotFoundResults
